<template>
  <div class="content-wrapper questionnaire-results">
    <div class="d-flex full-height justify-content-center">
      <div class="center">
        <div class="m-5">
          <div class="uppercase small-text pb-4">QUESTIONNAIRE RESULTS</div>
          <p class="sm-content general-content">
            Thank you for taking time to complete the questionaire. Based on
            your answers we reccommend to the following model. Select the
            passoni you prefer and begin the configuration process.
          </p>

          <div class="uppercase small-text all-models">
            <a v-on:click="viewAllModels">
              <button class="btn btn-outline-primary">VIEW ALL MODELS</button>
            </a>
          </div>
          
          <div class="spinner-wrapper d-flex justify-content-center align-items-center" v-if="resultBikes == null">
              <b-spinner label="Loading"></b-spinner>
          </div>

          <div class="spinner-wrapper d-flex justify-content-center align-items-center" v-if="noResults">
              No bikes were found
          </div>
          
          <div class="result-wrapper d-flex full-height justify-content-center" v-if="resultBikes != null">
            <div class="result" v-for="bike in this.resultBikes" v-bind:key="bike.id">
              <img
                :src="'/storage/' + bike.small_image"
                alt="Passoni Bike"
              />
              <h4 class="general-title">{{ bike.name }}</h4>
              <div class="uppercase small-text pb-4">
                TITANIUM/CARBON - RACING DESING<br />
                PERFECT FOR COMPETITION
              </div>
              <button class="btn btn-outline-primary" v-on:click="selectBike(bike)">
                CONFIGURE THIS MODEL
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "questionnaire-results",
  data() {
    return {
      resultBikes: null,
      noResults: false
    };
  },
  props: ["questionAnswers"],
  methods: {
    viewAllModels: function () {
      this.$emit("view-all-models");
    },
    calculateResult: function () {
      let parent = this;
      axios
        .post("/api/mtm-configurator/searchBikes", {
          material: this.questionAnswers.material,
          use: this.questionAnswers.use,
          brakes: this.questionAnswers.brakes,
          shifting: this.questionAnswers.shifting,
        })
        .then(function (res) {
          parent.resultBikes = res.data;
          if (res.data.length==0) {
            parent.noResults = true;
          }
        });
    },
    selectBike: function(bike) {
      this.$emit('select-bike', bike);
    }
  },
  created() {
    this.calculateResult();
  },
};
</script>

<style lang="scss" scoped>
.questionnaire-results {
  img {
    max-width: 360px;
    margin-bottom: 10px;
  }
  .all-models {
    margin-top: 30px;
    cursor: pointer;
  }
  .spinner-wrapper {
      min-height: 200px;
  }
}
</style>

